import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-details';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const CLEAR_FILTERS = `${NAMESPACE}/CLEAR_FILTERS`;
export const TOGGLE_FILTER = `${NAMESPACE}/TOGGLE_FILTER`;
export const TOGGLE_DEFAULT_TEAM_USER = `${NAMESPACE}/TOGGLE_DEFAULT_TEAM_USER`;
export const MOVED_SELECTED_USERS_TO_TEAM = `${NAMESPACE}/MOVED_SELECTED_USERS_TO_TEAM`;
export const INITIAL_DATA = createApiNamespacedConstants('initial_data');
export const TEAM_GET = createApiNamespacedConstants('team_get');
export const GET_TEAM_USERS_USAGE_CSV = createApiNamespacedConstants('GET_TEAM_USERS_USAGE_CSV');
export const DEFAULT_TEAM_USERS_GET = createApiNamespacedConstants('DEFAULT_TEAM_USERS_GET');
